<div class="text-center">
  @if(showSpiner) {
    <div class="spinner-border" role="status"></div>
    <div class="sr-only">Login is in progress...</div>
  }
</div>
<div class="text-center error">
  {{loginError}}
</div>
